import { i18n, DEFAULT_LOCALE } from './i18n'

type Locale = string

const loaded = new Set<string>([DEFAULT_LOCALE])

const localeModules = import.meta.glob('/src/locales/*.json')

export async function setLocale(locale: Locale): Promise<void> {
  if (!loaded.has(locale)) {
    const key = `/src/locales/${locale}.json`
    const loader = localeModules[key]

    if (!loader) {
      console.warn(`[i18n] Missing locale file: ${key}`)
      return
    }

    const messages = (await loader()) as { default: Record<string, unknown> }
    i18n.global.setLocaleMessage(locale, messages.default)
    loaded.add(locale)
  }

  i18n.global.locale.value = locale
  localStorage.setItem('locale', locale)
}

export function initLocale(): void {
  const saved = localStorage.getItem('locale')
  if (saved) void setLocale(saved)
}
